module.exports = __webpack_public_path__ + "static/analytics_img-9336ec47799173d2562f0c7a3e4e7e22.jpg";